import React from "react";
import "../styles/Quiz.css";

interface CompletionModalProps {
  onConfirm: () => void;
}

const CompletionModal: React.FC<CompletionModalProps> = ({ onConfirm }) => {
  return (
    <div className="modal-overlay">
      <div className="completion-modal">
        <h2>Assessment Completed</h2>

        <p>Once submitted, you cannot return or edit your answers.</p>

        <button className="quiz-btn" onClick={onConfirm}>
          Submit Assessment
        </button>
      </div>
    </div>
  );
};

export default CompletionModal;
